/* eslint-disable react/prop-types */
import { t } from "../../../services";
import { Checkbox, TextOverflowWrapper } from "../../../components";
import { CellWrapper } from "../../../components/Table/styled";

export const FilterOptionsTableColumns = (columnName, CellComponent) => [
  {
    id: "selecting",
    Header: ({ callbackFn2: selectAll, rows }) => {
      const isAllSelected = rows.every((x) => x.original.selected);
      const isAnySelected = !!rows.find((x) => x.original.selected);

      return (
        <Checkbox
          onCheck={(e) => {
            e.stopPropagation();
            selectAll(rows.map((x) => x.original));
          }}
          checked={isAllSelected}
          partiallyChecked={isAnySelected}
          disabled={rows.length === 0}
        />
      );
    },
    Cell: ({ cell, callbackFn1 }) => {
      const isSelected = cell.row.original.selected;

      return (
        <Checkbox
          onCheck={(e) => {
            e.stopPropagation();
            callbackFn1(cell.row.original.id);
          }}
          checked={isSelected}
        />
      );
    }
  },
  {
    Header: columnName,
    accessor: "value",
    Cell: ({ cell, cellWidth3, searchedText }) => {
      return CellComponent ? (
        <CellComponent cell={cell} width={cellWidth3 * 2} searchedText={searchedText} />
      ) : (
        <CellWrapper width={`${cellWidth3 * 2}px`}>
          <TextOverflowWrapper highlightedText={searchedText} width={`${cellWidth3 * 2}px`}>
            {t(cell.value)}
          </TextOverflowWrapper>
        </CellWrapper>
      );
    }
  }
];
